import { useEffect, useState } from "react";
import api from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { MessageCircle, Link2, Copy } from "lucide-react";
import { TEMPLATES, trackUrl } from "../lib/messages";
import { shareToCustomer } from "../lib/phone";
import { toast } from "sonner";

// Müşteriye iş takip linki + hazır mesaj (WhatsApp'ta açılır)
export default function JobMessageDialog({ open, onOpenChange, job, eta }) {
  const [tpl, setTpl] = useState("atandi");
  const [text, setText] = useState("");
  const [url, setUrl] = useState("");

  const build = async (key) => {
    setTpl(key); setText(TEMPLATES[key].build(job, url, "ServisPlus", eta));
  };
  useEffect(() => {
    if (!open || !job) return;
    setUrl(""); setText("");
    (async () => {
      const { data } = await api.post(`/jobs/${job.id}/track-link`); const u = trackUrl(data.token); setUrl(u);
      const key = job.status === "yolda" ? "yolda" : ["tamamlandi", "faturalandi"].includes(job.status) ? "bitti" : "atandi";
      setTpl(key); setText(TEMPLATES[key].build(job, u, "ServisPlus", eta));
    })();
    // eslint-disable-next-line
  }, [open, job?.id]);
  const handleOpen = (o) => onOpenChange(o);

  return (
    <Dialog open={open} onOpenChange={handleOpen}>
      <DialogContent data-testid="job-message-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><MessageCircle className="h-4 w-4 text-emerald-600" />Müşteriye mesaj</DialogTitle>
          <DialogDescription>Hazır mesaj müşterinin WhatsApp'ında açılır; göndermek için WhatsApp'ta "gönder"e basın. Link müşteriye iş durumunu, ustanın yolda olduğunu ve iş sonunda puanlama ekranını gösterir.</DialogDescription></DialogHeader>
        <div className="flex gap-1.5 flex-wrap">
          {Object.entries(TEMPLATES).map(([k, t]) => <Button key={k} size="sm" variant={tpl === k ? "default" : "outline"} className={tpl === k ? "bg-blue-600 hover:bg-blue-700" : ""} onClick={() => build(k)} data-testid={`tpl-${k}`}>{t.label}</Button>)}
        </div>
        <Textarea rows={5} value={text} onChange={(e) => setText(e.target.value)} data-testid="msg-text" />
        <div className="flex gap-2 flex-wrap">
          <Button className="flex-1 bg-emerald-600 hover:bg-emerald-700" onClick={() => shareToCustomer(job, text)} data-testid="msg-send"><MessageCircle className="h-4 w-4 mr-2" />{job?.phone_masked ? "Müşteriye gönder" : "WhatsApp'ta aç"}</Button>
          <Button variant="outline" onClick={() => { navigator.clipboard?.writeText(text); toast.success("Kopyalandı"); }}><Copy className="h-4 w-4 mr-1" />Kopyala</Button>
          <Button variant="outline" onClick={() => { navigator.clipboard?.writeText(url); toast.success("Takip linki kopyalandı"); }}><Link2 className="h-4 w-4 mr-1" />Link</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
